import { render, staticRenderFns } from "./error.vue?vue&type=template&id=7684d39d&"
import script from "./error.component.ts?vue&type=script&lang=ts&"
export * from "./error.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports